<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li>请于页面规定时间内完成支付，请勿超时支付，若已超时请重新提案，依照新提案收款规定时间内支付。</li>
      <li>支付宝操作，直接选择转账支付，勿使用红包付款。</li>
      <li>请勿重复打款、金额错误，需依照当下页面收款方、金额进行支付。</li>
      <li style="color: #ff5455">请务必遵守以上，否则将无法追回，需自行承担，敬请留意!!!</li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'ElectronicAlert'
  }
</script>
